import {GET_EVENTS} from '../../../constants/MonitorConstants';
import {GeneralAction} from "../../../@types/actions";

export const GetEventsAction = (filters: Record<string, any>): GeneralAction<Record<string, any>> => ({
    type: GET_EVENTS,
    payload: filters
});
